export const DOCUMENT_NAMES_TO_REMOVE = [
    'fastjson',
    'Calculos'
];
